import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCalendarDays,
	faChevronDown,
	faUser,
	faHouse,
	faTicket,
	faCartShopping,
	faUserGroup,
	faQuoteLeft,
	faTruckFast,
	faGears,
	faGear,
	faCopy,
	faBook,
	faCodeFork,
	faFileContract,
	faChartPie,
	faShop,
	faDumbbell,
	faLocationDot,
	faRotateRight,
	faFileExcel,
	faFileLines,
	faMobileScreenButton,
	faCloudArrowDown,
	faListCheck,
	faUsersGear,
	faUserTie,
	faClockRotateLeft,
	faBookOpen,
	faGraduationCap,
	faCertificate,
	faCoins,
	faLightbulb,
	faSatelliteDish,
	faClock,
	faSliders,
	faChartLine,
	faBoxesStacked,
	faMicrochip,
	faTruckRampBox,
	faDiagramProject,
	faFileCirclePlus,
	faFileSignature,
	faUsersViewfinder,
	faAddressBook,
	faIdBadge,
	faImage,
	faBug,
	faChartColumn,
	faReceipt,
	faWarehouse,
	faClipboardQuestion,
	faScrewdriverWrench,
	faBoxesPacking,
	faMapPin,
	faTimeline,
	faClipboardUser,
	faEnvelope,
	faBell
} from "@fortawesome/free-solid-svg-icons";
import { Link as RouterLink, Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import ArrowDown from "../components/ui/arrowDown";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";

import useFetchSelector from "../hooks/useFetchSelector";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NEW_FEATURES = [
	{
		key: "log-analyzer",
		version: "2026-07-23",
		path: "/log-analyzer",
		title: "Log Analyzer",
		description: "Nueva herramienta para analizar paquetes de logs SQL/NEXIM.",
	},
	{
		key: "technical-insights",
		version: "2026-07-23",
		path: "/SRM/technical-insights",
		title: "Technical Insights",
		description: "Nuevo dashboard de fallas recurrentes y calidad de reportes SRM.",
	},
	{
		key: "fse-insights",
		version: "2026-07-23",
		path: "/SRM/fse-insights",
		title: "FSE Insights",
		description: "Nueva vista de desempeño, experiencia y aging por FSE.",
	},
	{
		key: "email-logs",
		version: "2026-08-04",
		path: "/utils/email-logs",
		title: "Email Logs",
		description: "Nueva vista para revisar intentos, contenido y estado de correos enviados.",
	},
];

const PERMISSION_ALIASES = {
	expense: ["expense", "expenses"],
	expenses: ["expense", "expenses"],
	loganalyzer: ["logAnalyzer"],
	reportsapp: ["reportsApp"],
	purchaseorders: ["purchaseOrders"],
	userviewer: ["userViewer"],
};

const normalizePermissionKey = key =>
	String(key || "")
		.trim()
		.toLowerCase()
		.replace(/[\s_-]/g, "");

const normalizePermissions = (...sources) =>
	sources.reduce((acc, source) => {
		Object.entries(source || {}).forEach(([key, value]) => {
			const cleanKey = String(key || "").trim();
			if (!cleanKey) return;
			acc[cleanKey] = value;
			const aliases = PERMISSION_ALIASES[normalizePermissionKey(cleanKey)] || [];
			aliases.forEach(alias => {
				acc[alias] = value;
			});
		});
		return acc;
	}, {});

/**
 * El manual lo sirve el backend como archivo estatico, asi que su direccion se
 * deriva del API quitandole el sufijo /api/v1/.
 */
const scheduleManualUrl = () => {
	const api = process.env.REACT_APP_API_URL || "";
	const origen = api.replace(/\/api\/v1\/?$/, "").replace(/\/$/, "");
	return `${origen}/public/manuals/schedule.html`;
};

const Menu = props => {
	const { userType, permissions } = props.roles;
	const appMemberships = (() => {
		try {
			const fromAuth = props?.roles?.appMemberships;
			if (fromAuth && typeof fromAuth === "object") return fromAuth;
			const raw = localStorage.getItem("appMemberships");
			return raw ? JSON.parse(raw) : {};
		} catch {
			return {};
		}
	})();
	const effectivePermissions = normalizePermissions(permissions, appMemberships);
	const hasPermission = (...keys) =>
		keys.some((k) => {
			const v = effectivePermissions?.[k];
			return v !== undefined && v !== null && String(v).trim() !== "";
		});
	localStorage.setItem("tickets", effectivePermissions.tickets || "");
	localStorage.setItem("quotes", effectivePermissions.quotes || "");
	localStorage.setItem("doc", effectivePermissions.doc || "");
	const [utilsDropdownOpen, setUtilsDropdownOpen] = useState(false);
	const [reportsDropdownOpen, setReportsDropdownOpen] = useState(false);
	const [jigsDropdownOpen, setJigsDropdownOpen] = useState(false);
	const [scheduleDropdownOpen, setScheduleDropdownOpen] = useState(false);
	const [expensesDropdownOpen, setExpensesDropdownOpen] = useState(false);
	const [warehouseDropdownOpen, setWarehouseDropdownOpen] = useState(false);
	const [immexDropdownOpen, setImmexDropdownOpen] = useState(false);
	const [headDropdownOpen, setHeadDropdownOpen] = useState(false);
	const [ticketsDropdownOpen, setTicketsDropdownOpen] = useState(false);
	const [quotesDropdownOpen, setQuotesDropdownOpen] = useState(false);
	const [poDropdownOpen, setPoDropdownOpen] = useState(false);
	const [trainingDropdownOpen, setTrainingDropdownOpen] = useState(false);
	const [geofenceDropdownOpen, setGeofenceDropdownOpen] = useState(false);
	const [thingsToDoDropdownOpen, setThingsToDoDropdownOpen] = useState(false);
	const [menuOpen, setMenuOpen] = useState(true);
	const [theme, setTheme] = useState(localStorage.getItem("theme"));
	const [appSelected, setAppSelected] = useState("");
	const [backendHealth, setBackendHealth] = useState("checking");
	const [lastHealthCheckAt, setLastHealthCheckAt] = useState(null);
	const [seenFeatureKeys, setSeenFeatureKeys] = useState(new Set());
	const [featureViewsLoaded, setFeatureViewsLoaded] = useState(false);
	const { setAuth } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const isDashboardPage = location.pathname === "/dashboard";
	const userName = localStorage.getItem("userName") || "";
	const userId = localStorage.getItem("userId") || "";
	const clientName = localStorage.getItem("clientName") || "";
	const clientId = localStorage.getItem("clientId") || "";
	const clientCredits = localStorage.getItem("clientCredits") || "";
	const permissionsTraining = effectivePermissions.training || localStorage.getItem("permissions.training") || "";
	const [creditsValue, setCreditsValue] = useState(clientCredits);
	const [userAvatar, setUserAvatar] = useState(localStorage.getItem("profileImg") || "");

	const resolveAvatar = value => {
		const raw = String(value || "").trim();
		if (!raw) return "";
		if (raw.startsWith("http://") || raw.startsWith("https://") || raw.startsWith("data:image/")) return raw;
		if (raw.startsWith("/")) return raw;
		return `/${raw}`;
	};

	const roleLabel = () => {
		if (appSelected.toLowerCase().includes("training")) {
			return permissionsTraining || "user";
		}
		return userType || "user";
	};
	const normalizedUserType = String(userType || "").toLowerCase().trim();
	const normalizedScheduleRole = String(effectivePermissions.scheduleV2 || effectivePermissions.schedule || "")
		.toLowerCase()
		.trim();
	const canManageSchedule =
		normalizedScheduleRole === "admin" ||
		normalizedScheduleRole === "superuser" ||
		normalizedScheduleRole === "super user";
	const isSuperUser =
		normalizedUserType === "super user" ||
		normalizedUserType === "super_user" ||
		normalizedUserType === "superuser";
	const isAdminUser = normalizedUserType === "admin";
	const isGeofenceAdmin = String(effectivePermissions.geofence || "").toLowerCase() === "admin";
	const canViewSrmInsights =
		String(effectivePermissions.reports || "").toLowerCase() === "admin" ||
		String(effectivePermissions.reportsApp || "").toLowerCase() === "admin";
	const canViewFeature = feature => {
		if (feature.key === "log-analyzer") return hasPermission("logAnalyzer") || effectivePermissions.utils === "admin";
		if (feature.key === "technical-insights" || feature.key === "fse-insights") return canViewSrmInsights;
		if (feature.key === "email-logs") return effectivePermissions.utils === "admin";
		return true;
	};
	const appAccent = (() => {
		const selected = String(appSelected || "").toLowerCase();
		if (selected.includes("training")) return "training";
		if (selected.includes("purchase") || selected.includes("po ")) return "po";
		if (selected.includes("report") || selected.includes("srm")) return "reports";
		if (selected.includes("quote")) return "quotes";
		if (selected.includes("log analyzer") || selected.includes("email logs")) return "utils";
		if (selected.includes("ticket")) return "tickets";
		if (selected.includes("util") || selected.includes("client") || selected.includes("user") || selected.includes("employee")) return "utils";
		return "default";
	})();
	const currentPageTitle = appSelected || "Home";
	const currentSectionLabel = appAccent === "default" ? "PAC workspace" : appAccent;
	const routeMatches = routes =>
		routes.some(route => {
			if (!route) return false;

			if (route.endsWith("/*")) {
				const baseRoute = route.slice(0, -2);
				return location.pathname === baseRoute || location.pathname.startsWith(`${baseRoute}/`);
			}

			return location.pathname === route || location.pathname.startsWith(`${route}/`);
		});
	const sectionRoutes = {
		reports: ["/reportsLegacy/*", "/SRM/*", "/utils/changeLog/reports"],
		training: ["/training/*", "/utils/changeLog/training"],
		geofence: ["/geofence/*"],
		heads: ["/heads/*"],
		immex: ["/immex/*", "/warehouse/machinetracker"],
		warehouse: [
			"/warehouse/lcubox",
			"/warehouse/cpu",
			"/warehouse/delivery",
			"/warehouse/bom",
			"/warehouse/partnumber",
		],
		expenses: ["/user/home", "/user/historical", "/user/budget", "/user/expense"],
		schedule: ["/schedule/*", "/schedule-v2/*", "/utils/changeLog/schedule"],
		tickets: ["/tickets/*"],
		jigs: ["/jigs", "/jigsTable", "/jigsDashboard", "/utils/changeLog/jigs"],
		purchaseOrders: ["/po/*", "/utils/changeLog/purchaseOrders"],
		quotes: ["/quotes", "/quotes/*", "/utils/changeLog/quotes"],
		utils: [
			"/utils/clients",
			"/utils/clients-new",
			"/utils/users",
			"/utils/email-logs",
			"/utils/employees",
			"/utils/tyc",
			"/utils/changeLog/utils",
			"/utils/jobs",
			"/utils/public-images",
		],
		workflow: ["/workflow", "/workflow/*"],
	};
	const sectionClassName = sectionKey =>
		`w-full flex justify-between ${
			routeMatches(sectionRoutes[sectionKey] || []) ? "pac-section-active" : ""
		}`.trim();
	const Link = ({ to, className = "", children, ...linkProps }) => {
		if (!to) {
			return (
				<a className={className} {...linkProps}>
					{children}
				</a>
			);
		}

		const targetPath = typeof to === "string" ? to.split("?")[0] : to?.pathname;
		const isActive =
			!!targetPath &&
			(location.pathname === targetPath ||
				(targetPath !== "/" && location.pathname.startsWith(`${targetPath}/`)));
		const resolvedClassName = `${className} ${isActive ? "pac-menu-active" : ""}`.trim();

		return (
			<RouterLink
				to={to}
				className={resolvedClassName}
				aria-current={isActive ? "page" : undefined}
				{...linkProps}
			>
				{children}
			</RouterLink>
		);
	};
	const featureViewKey = feature => `${feature.key}:${feature.version}`;
	const findFeatureByPath = pathname =>
		NEW_FEATURES.find(feature => pathname === feature.path || pathname.startsWith(`${feature.path}/`));
	const shouldShowNewBadge = featureKey => {
		if (!featureViewsLoaded) return false;
		const feature = NEW_FEATURES.find(item => item.key === featureKey);
		return feature && canViewFeature(feature) ? !seenFeatureKeys.has(featureViewKey(feature)) : false;
	};
	const newFeatureNotifications = featureViewsLoaded
		? NEW_FEATURES.filter(feature => canViewFeature(feature) && !seenFeatureKeys.has(featureViewKey(feature)))
		: [];
	const NewFeatureBadge = ({ featureKey }) =>
		shouldShowNewBadge(featureKey) ? (
			<span
				data-testid={`new-feature-badge-${featureKey}`}
				className="ml-auto rounded-full bg-sky-400 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-slate-950 shadow-sm shadow-sky-900/20"
			>
				NEW
			</span>
		) : null;

	//EXPENSES
	useFetchSelector(`${process.env.REACT_APP_API_URL}users_selector`, 'users');
	useFetchSelector(`${process.env.REACT_APP_API_URL}principal_selector`, 'principals');
	useFetchSelector(`${process.env.REACT_APP_API_URL}status_selector`, 'status');
	useFetchSelector(`${process.env.REACT_APP_API_URL}clients_selector`, 'clients');
	useFetchSelector(`${process.env.REACT_APP_API_URL}expenses_types_selector`, 'expense_types');
	useFetchSelector(`${process.env.REACT_APP_API_URL}butget_types_selector`, 'budget_types');

	//USER VIEWER
	useFetchSelector(`${process.env.REACT_APP_API_URL}user_department_selector`, 'user_departments');
	useFetchSelector(`${process.env.REACT_APP_API_URL}user_location_selector`, 'user_locations');
	useFetchSelector(`${process.env.REACT_APP_API_URL}user_organization_selector`, 'user_organizations');
	useFetchSelector(`${process.env.REACT_APP_API_URL}user_position_selector`, 'user_positions');

	const toggleTheme = () => {
		localStorage.setItem("theme", theme === "dark" ? "light" : "dark");
		setTheme(theme === "dark" ? "light" : "dark");
	};

	const handleLogout = () => {
		axios.delete(`${process.env.REACT_APP_API_URL}logout`, { withCredentials: true }).finally(() => {
			setAuth({});
			localStorage.removeItem("auth");
			navigate("/", { replace: true });
		});
	};

	useEffect(() => {
		document.querySelector("html").setAttribute("data-theme", theme);
	}, [theme]);

	useEffect(() => {
		let mounted = true;

		const checkBackendHealth = async () => {
			try {
				const baseUrl = process.env.REACT_APP_API_URL || "";
				const response = await fetch(`${baseUrl}health`, { method: "GET" });
				if (!mounted) return;
				if (response.ok) {
					setBackendHealth("online");
					setLastHealthCheckAt(new Date());
				} else {
					setBackendHealth("offline");
				}
			} catch (error) {
				if (!mounted) return;
				setBackendHealth("offline");
			}
		};

		checkBackendHealth();
		const intervalId = setInterval(checkBackendHealth, 20000);

		return () => {
			mounted = false;
			clearInterval(intervalId);
		};
	}, []);

	useEffect(() => {
		const handler = () => {
			setCreditsValue(localStorage.getItem("clientCredits") || "");
		};
		window.addEventListener("credits-updated", handler);
		return () => window.removeEventListener("credits-updated", handler);
	}, []);

	useEffect(() => {
		const localImg = resolveAvatar(localStorage.getItem("profileImg"));
		if (localImg) setUserAvatar(localImg);
		if (!userId) return;
		const endpoint = `${process.env.REACT_APP_API_URL}users/${userId}/profile-settings`;
		let cancelled = false;
		axios
			.get(endpoint, { headers: { "Content-Type": "application/json" } })
			.then(res => {
				if (cancelled) return;
				const remoteImg = resolveAvatar(res?.data?.data?.profileImg || "");
				if (remoteImg) {
					setUserAvatar(remoteImg);
					localStorage.setItem("profileImg", remoteImg);
				}
			})
			.catch(() => {});
		return () => {
			cancelled = true;
		};
	}, [userId]);

	useEffect(() => {
		if (!userId) return;
		const baseUrl = process.env.REACT_APP_API_URL;
		if (!baseUrl) return;
		let cancelled = false;

		fetch(`${baseUrl}userFeatureViews?userId=${encodeURIComponent(userId)}`)
			.then(res => (res.ok ? res.json() : []))
			.then(rows => {
				if (cancelled) return;
				const seen = new Set(
					Array.isArray(rows)
						? rows.map(row => `${row.featureKey}:${row.featureVersion}`)
						: []
				);
				setSeenFeatureKeys(seen);
				setFeatureViewsLoaded(true);
			})
			.catch(() => {
				if (!cancelled) setFeatureViewsLoaded(false);
			});

		return () => {
			cancelled = true;
		};
	}, [userId]);

	useEffect(() => {
		if (!userId || !featureViewsLoaded) return;
		const feature = findFeatureByPath(location.pathname);
		if (!feature || seenFeatureKeys.has(featureViewKey(feature))) return;
		const baseUrl = process.env.REACT_APP_API_URL;
		if (!baseUrl) return;

		setSeenFeatureKeys(prev => new Set([...prev, featureViewKey(feature)]));
		fetch(`${baseUrl}userFeatureViews/markSeen`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				userId: Number(userId),
				featureKey: feature.key,
				featureVersion: feature.version,
			}),
		}).catch(() => {
			setSeenFeatureKeys(prev => {
				const next = new Set(prev);
				next.delete(featureViewKey(feature));
				return next;
			});
		});
	}, [featureViewsLoaded, location.pathname, seenFeatureKeys, userId]);

	useEffect(() => {
		const missingCredits = !clientCredits || clientCredits === "null";
		if (!missingCredits || !clientId) {
			setCreditsValue(clientCredits);
			return;
		}
		const baseUrl = process.env.REACT_APP_API_URL;
		if (!baseUrl) return;
		let cancelled = false;
		fetch(`${baseUrl}clients_selector`)
			.then(res => (res.ok ? res.json() : []))
			.then(data => {
				if (cancelled) return;
				const client = Array.isArray(data)
					? data.find(c => String(c.id) === String(clientId))
					: null;
				const credits = client?.credits ?? "";
				setCreditsValue(credits);
				localStorage.setItem("clientCredits", credits ?? "");
			})
			.catch(() => {});
		return () => {
			cancelled = true;
		};
	}, [clientCredits, clientId]);

	const close = e => {
		setMenuOpen(!menuOpen);
		document.getElementById("my-drawer-3").click();
	};

	const handleReloadPage = () => {
		window.location.reload();
	};

	return (
	<div
		className={`drawer h-screen drawer-mobile transition-all delay-150 duration-300 ease-in-out   ${
			menuOpen ? "" : ""
		}`}
	>
		<input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
		<div className="drawer-content  flex flex-col transition-all delay-1000 duration-1000 ease-in-out">
			<div
				className={`navbar pac-topbar pac-shell-accent-${appAccent} flex justify-between`}
				data-testid="pac-topbar"
			>
				<div className="pac-topbar-heading">
					<div className="flex-none ">
						<label htmlFor="my-drawer-3" className="btn btn-square btn-ghost pac-topbar-button">
							<svg
								className="swap-off fill-current"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								viewBox="0 0 512 512"
							>
								<path d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z" />
							</svg>
						</label>
					</div>

					{/*<label className="btn btn-circle swap swap-rotate  lg:hidden">
							<input
								type="checkbox"
								onClick={() => close()}
							/>

							<svg
								className="swap-off fill-current"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								viewBox="0 0 512 512"
							>
								<path d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z" />
							</svg>

							<svg
								className="swap-on fill-current"
								xmlns="http://www.w3.org/2000/svg"
								width="32"
								height="32"
								viewBox="0 0 512 512"
							>
								<polygon points="400 145.49 366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49" />
							</svg>
						</label>*/}

					<div className="pac-title-stack">
						<span className={`pac-title-kicker pac-title-kicker-${appAccent}`}>
							{currentSectionLabel}
						</span>
						<h1 className="pac-page-title">{currentPageTitle}</h1>
					</div>
				</div>

				<div className="order-last flex items-center gap-4 pac-topbar-actions">
					<div
						className={`pac-health-pill hidden md:flex items-center gap-2 rounded-full border px-3 py-1 text-xs ${
							backendHealth === "online"
								? "border-emerald-200 bg-emerald-50 text-emerald-700"
								: backendHealth === "offline"
									? "border-rose-200 bg-rose-50 text-rose-700"
									: "border-amber-200 bg-amber-50 text-amber-700"
						}`}
						title={lastHealthCheckAt ? `Last check: ${lastHealthCheckAt.toLocaleTimeString()}` : "Checking backend status..."}
					>
						<span className={`inline-block h-2 w-2 rounded-full ${
							backendHealth === "online" ? "bg-emerald-500" : backendHealth === "offline" ? "bg-rose-500" : "bg-amber-500"
						}`}></span>
						<span>
							{backendHealth === "online" ? "Backend online" : backendHealth === "offline" ? "Backend offline" : "Checking backend..."}
						</span>
					</div>
					<div className="dropdown dropdown-end">
						<button
							type="button"
							tabIndex={0}
							className="btn btn-ghost btn-circle pac-topbar-button relative"
							aria-label="New feature notifications"
							title="New feature notifications"
						>
							<FontAwesomeIcon icon={faBell} />
							{newFeatureNotifications.length ? (
								<span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-sky-400 px-1 text-[10px] font-black text-slate-950 ring-2 ring-white">
									{newFeatureNotifications.length}
								</span>
							) : null}
						</button>
						<div
							tabIndex={0}
							className="dropdown-content z-30 mt-3 w-80 rounded-2xl border border-slate-200 bg-white p-3 text-slate-800 shadow-2xl shadow-slate-900/15"
						>
							<div className="flex items-center justify-between border-b border-slate-100 pb-2">
								<div>
									<div className="text-sm font-black text-slate-950">Notifications</div>
									<div className="text-xs text-slate-500">New features available</div>
								</div>
								<span className="rounded-full bg-slate-100 px-2 py-1 text-xs font-bold text-slate-600">
									{newFeatureNotifications.length}
								</span>
							</div>
							<div className="mt-3 space-y-2">
								{newFeatureNotifications.length ? (
									newFeatureNotifications.map(feature => (
										<RouterLink
											key={feature.key}
											to={feature.path}
											className="block rounded-xl border border-sky-100 bg-sky-50 p-3 text-left transition hover:border-sky-200 hover:bg-sky-100"
										>
											<div className="flex items-center justify-between gap-3">
												<span className="text-sm font-black text-slate-950">{feature.title}</span>
												<span className="rounded-full bg-sky-400 px-2 py-0.5 text-[10px] font-black text-slate-950">
													NEW
												</span>
											</div>
											<div className="mt-1 text-xs leading-relaxed text-slate-600">{feature.description}</div>
										</RouterLink>
									))
								) : (
									<div className="rounded-xl bg-slate-50 p-3 text-sm text-slate-500">
										No new feature notifications.
									</div>
								)}
							</div>
						</div>
					</div>
					<button
						type="button"
						className="btn btn-ghost btn-circle pac-topbar-button"
						onClick={handleReloadPage}
						title="Reload current page"
						aria-label="Reload current page"
					>
						<FontAwesomeIcon icon={faRotateRight} />
					</button>
					<label className="swap swap-rotate pac-theme-toggle">
						<input onClick={toggleTheme} type="checkbox" />
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth="1.5"
							stroke="currentColor"
							aria-hidden="true"
							data-set-theme="light"
							className="fill-current w-6 h-6 swap-on"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
							></path>
						</svg>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth="1.5"
							stroke="currentColor"
							aria-hidden="true"
							data-set-theme="dark"
							className="fill-current w-6 h-6 swap-off ACTIVECLASS"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
							></path>
						</svg>
					</label>

					<div className="dropdown dropdown-end ml-4">
						<label tabIndex={0} className="btn btn-ghost btn-circle avatar pac-avatar-button">
							<div className="w-10 rounded-full leading-10 pac-avatar-ring">
								{userAvatar ? (
									<img src={userAvatar} alt="User avatar" className="h-10 w-10 rounded-full object-cover" />
								) : (
									<FontAwesomeIcon icon={faUser} size="xl" />
								)}
							</div>
						</label>
						<ul
							tabIndex={0}
							className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52 z-20 pac-user-dropdown"
						>
							<li className="justify-between">
								<Link to="/profile" onClick={() => setAppSelected("Profile Settings")}>
									Profile Settings
									<span className="badge hidden">disabled</span>
								</Link>
							</li>
							<div className="divider mt-0 mb-0"></div>
							<li>
								<button type="button" onClick={handleLogout}>
									Logout
								</button>
							</li>
						</ul>
					</div>
					<div className="hidden md:flex flex-col items-start text-left pac-user-summary">
						<span className="text-sm font-semibold pac-user-name">
							{clientName ? `${userName} · ${clientName}` : userName}
						</span>
						<span className="text-xs pac-user-role">{roleLabel()}</span>
						{!!creditsValue && creditsValue !== "null" && (
							<span className="text-xs pac-user-role">
								Credits: {Number(creditsValue) < 0 ? "∞" : creditsValue}
							</span>
						)}
					</div>
				</div>
			</div>

				{appSelected === "Reports Charts" ? (
				<main
					className="pac-main-shell max-h-[calc(100vh-64px)] flex-1 overflow-y-auto bg-base-200 border-box"
					data-testid="pac-main-shell"
				>
					<Outlet />
				</main>
			) : (
				<main
					className={`pac-main-shell max-h-[calc(100vh-64px)] flex-1 bg-base-200 border-box ${
						isDashboardPage ? "overflow-hidden p-0" : "overflow-y-auto p-4"
					}`}
					data-testid="pac-main-shell"
				>
					<Outlet />
				</main>
			)}
		</div>
		<div className="drawer-side pac-drawer-side transition-all delay-150 duration-300 ease-in-out z-50">
			<label htmlFor="my-drawer-3" className="drawer-overlay"></label>
			<ul
				className="menu pac-sidebar p-4 w-80 h-screen z-50 flex flex-nowrap	overflow-x-hidden overflow-y-auto"
				data-testid="pac-sidebar"
			>
				<li className="mb-2 mt-2 font-semibold text-xl pac-sidebar-brand">
					<div className="flex justify-center">
						<img
							className="w-48 text-base-100"
							src="/images/pacLogoWhite.svg"
							alt="PAC"
						/>
					</div>
				</li>
				<li className="pac-sidebar-eyebrow">Navigation</li>
				<li>
					<Link
						to="/dashboard"
						className="w-full"
						onClick={() => {
							setAppSelected("Home");
							document.getElementById("my-drawer-3").checked = false;
						}}
					>
						<FontAwesomeIcon icon={faHouse} />
						Home
					</Link>
				</li>

				{hasPermission("logAnalyzer") || effectivePermissions.utils === "admin" ? (
					<li>
						<Link
							to="/log-analyzer"
							className="w-full"
							onClick={() => {
								setAppSelected("Log Analyzer");
								document.getElementById("my-drawer-3").checked = false;
							}}
						>
							<FontAwesomeIcon icon={faBug} />
							Log Analyzer
							<NewFeatureBadge featureKey="log-analyzer" />
						</Link>
					</li>
				) : (
					<></>
				)}

				{hasPermission("reports", "reportsApp") ? (
					<li>
						<div
							className={sectionClassName("reports")}
							data-testid="menu-section-reports"
							onClick={() =>
								setReportsDropdownOpen(reportsDropdownOpen => !reportsDropdownOpen)
							}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faFileContract} className="mr-2" />
								Service Reports Mobile
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!reportsDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!reportsDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								{effectivePermissions.reports == "admin" ? (
									<li className="w-full">
										<Link
											to="/reportsLegacy/charts"
											className="w-full"
											onClick={() => {
												setAppSelected("Reports Charts");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faChartPie} />
											Reports Legacy Charts
										</Link>
									</li>
								) : (
									<></>
								)}

								<li className="w-full">
									<Link
										to="/reportsLegacy/table"
										className="w-full"
										onClick={() => {
											setAppSelected("Reports Charts");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileLines} />
										Reports Legacy Table
									</Link>
								</li>

								{effectivePermissions.reports == "admin" ? (
									<>
										<li className="w-full">
											<Link
												to="/SRM/dashboard"
												className="w-full"
												onClick={() => {
													setAppSelected("SRM Dashboard");
													document.getElementById("my-drawer-3").checked = false;
												}}
											>
												<FontAwesomeIcon icon={faChartColumn} />
												SRM Dashboard
											</Link>
										</li>

									</>
								) : (
									<></>
								)}

								<li className="w-full">
									<Link
										to="/SRM/table"
										className="w-full"
										onClick={() => {
											setAppSelected("SRM Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faMobileScreenButton} />
										SRM Table
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/SRM/offline-reports"
										className="w-full"
										onClick={() => {
											setAppSelected("Offline Reports");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCloudArrowDown} />
										Offline Reports
									</Link>
								</li>
								{canViewSrmInsights ? (
									<>
										<li className="w-full">
											<Link
												to="/SRM/technical-insights"
												className="w-full"
												onClick={() => {
													setAppSelected("Technical Insights");
													document.getElementById("my-drawer-3").checked = false;
												}}
											>
												<FontAwesomeIcon icon={faLightbulb} />
												Technical Insights
												<NewFeatureBadge featureKey="technical-insights" />
											</Link>
										</li>
										<li className="w-full">
											<Link
												to="/SRM/fse-insights"
												className="w-full"
												onClick={() => {
													setAppSelected("FSE Insights");
													document.getElementById("my-drawer-3").checked = false;
												}}
											>
												<FontAwesomeIcon icon={faIdBadge} />
												FSE Insights
												<NewFeatureBadge featureKey="fse-insights" />
											</Link>
										</li>
									</>
								) : null}
								{isSuperUser || isAdminUser ? (
									<li className="w-full">
										<Link
											to="/SRM/assign-areas"
											className="w-full"
											onClick={() => {
												setAppSelected("Assign Areas");
												document.getElementById("my-drawer-3").checked = false;
											}}
											>
											<FontAwesomeIcon icon={faUsersGear} />
											Assign Areas
										</Link>
									</li>
								) : null}
								{isSuperUser || isAdminUser ? (
									<li className="w-full">
										<Link
											to="/SRM/assign-coordinators"
											className="w-full"
											onClick={() => {
												setAppSelected("Assign Coordinators");
												document.getElementById("my-drawer-3").checked = false;
											}}
											>
											<FontAwesomeIcon icon={faUserTie} />
											Assign Coordinators
										</Link>
									</li>
								) : null}
									<li className="w-full">
									<Link
										to="/utils/changeLog/reports"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}


				{hasPermission("training") ? (
					<li>
						<div
							className={sectionClassName("training")}
							data-testid="menu-section-training"
							onClick={() =>
								setTrainingDropdownOpen(trainingDropdownOpen => !trainingDropdownOpen)
							}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faDumbbell} className="mr-2" />
								Training
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!trainingDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!trainingDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">

								{permissionsTraining === "admin" || permissionsTraining === "instructor" ? (
									<li className="w-full">
										<Link
											to="/training/dashboard"
											className="w-full"
											onClick={() => {
												setAppSelected("Training Dashboard");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faChartPie} />
											Dashboard
										</Link>
									</li>
								) : null}
								<li className="w-full">
									<Link
										to="/training/calendar"
										className="w-full"
										onClick={() => {
											setAppSelected("Training Calendar");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCalendarDays} />
										Calendar
									</Link>
								</li>
								{permissionsTraining === "admin" || permissionsTraining === "instructor" ? (
									<li className="w-full">
										<Link
											to="/training/summary"
											className="w-full"
											onClick={() => {
												setAppSelected("Training Summary");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faFileExcel} />
											Summary
										</Link>
									</li>
								) : null}
								<li className="w-full">
									<Link
										to="/training/courses"
										className="w-full"
										onClick={() => {
											setAppSelected("Training Courses");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBookOpen} />
										Courses
									</Link>
								</li>
								{permissionsTraining === "admin" || isSuperUser ? (
									<li className="w-full">
										<Link
											to="/training/courses-old"
											className="w-full"
											onClick={() => {
												setAppSelected("Training Courses OLD");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faGraduationCap} />
											Courses OLD
										</Link>
									</li>
								) : null}
								<li className="w-full">
									<Link
										to="/training/completed"
										className="w-full"
										onClick={() => {
											setAppSelected("Training Completed");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCertificate} />
										Completed
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/training/credits"
										className="w-full"
										onClick={() => {
											setAppSelected("Training Credits");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCoins} />
										Credits
									</Link>
								</li>
								{permissionsTraining === "client" && (
									<li className="w-full">
										<Link
											to="/training/my-users"
											className="w-full"
											onClick={() => {
												setAppSelected("Training My Users");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faUsersGear} />
											My Users
										</Link>
									</li>
								)}
								<li className="w-full">
									<Link
										to="/training/suggestions"
										className="w-full"
										onClick={() => {
											setAppSelected("Training Suggestions");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faLightbulb} />
										Suggestions
									</Link>
								</li>
								{permissionsTraining === "admin" && (
									<li className="w-full">
										<Link
											to="/training/users"
											className="w-full"
											onClick={() => {
												setAppSelected("Training Users");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faUserGroup} />
											Users
										</Link>
									</li>
								)}
								{permissionsTraining === "admin" && (
									<li className="w-full">
										<Link
											to="/training/email-settings"
											className="w-full"
											onClick={() => {
												setAppSelected("Training Email Settings");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faEnvelope} />
											Email Settings
										</Link>
									</li>
								)}


								<li className="w-full">
									<Link
										to="/utils/changeLog/training"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{isGeofenceAdmin && (
					<li>
						<div
							className={sectionClassName("geofence")}
							data-testid="menu-section-geofence"
							onClick={() => setGeofenceDropdownOpen(prev => !prev)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faLocationDot} className="mr-2" />
								Geofences
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!geofenceDropdownOpen && "rotate-180"
								}`}
							/>
						</div>
						<div
							className={`${
								!geofenceDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/geofence/en-vivo"
										className="w-full"
										onClick={() => {
											setAppSelected("Geofence · En vivo");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faSatelliteDish} />
										En vivo
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/geofence/historial"
										className="w-full"
										onClick={() => {
											setAppSelected("Geofence · Historial");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Historial
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/geofence/horas"
										className="w-full"
										onClick={() => {
											setAppSelected("Geofence · Horas");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClock} />
										Horas
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/geofence/analisis"
										className="w-full"
										onClick={() => {
											setAppSelected("Geofence · Análisis");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faChartLine} />
										Análisis
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/geofence/configuracion"
										className="w-full"
										onClick={() => {
											setAppSelected("Geofence · Configuración");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faSliders} />
										Configuración
									</Link>
								</li>
							</ul>
						</div>
					</li>
				)}


				{hasPermission("userViewer") && (
					<li>
						<Link
							to="/user/viewer"
							className="w-full"
							onClick={() => {
								setAppSelected("Users Viewer");
								document.getElementById("my-drawer-3").checked = false;
							}}
						>
							<FontAwesomeIcon icon={faUsersViewfinder} />
							User Viewer v1.1
						</Link>
					</li>
				)}
				{hasPermission("Heads", "heads") ? ( //despues agregar permisos especiales
					<li>
						<div
							className={sectionClassName("heads")}
							data-testid="menu-section-heads"
							onClick={() => setHeadDropdownOpen(headDropdownOpen => !headDropdownOpen)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faUserTie} className="mr-2" />
								Heads
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!headDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!headDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/heads/headviwer"
										className="w-full"
										onClick={() => {
											setAppSelected("Head Viewer");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faUserTie} />
										Head Viewer
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}
				{hasPermission("immex") ? ( //despues agregar permisos especiales
					<li>
						<div
							className={sectionClassName("immex")}
							data-testid="menu-section-immex"
							onClick={() => setImmexDropdownOpen(immexDropdownOpen => !immexDropdownOpen)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faWarehouse} className="mr-2" />
								IMMEX Warehouse
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!immexDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!immexDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/immex/partnumber"
										className="w-full"
										onClick={() => {
											setAppSelected("Partnumbers");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBoxesStacked} />
										Partnumbers
									</Link>
								</li>
								<li>
									<Link
										to="/immex/pedimento"
										className="w-full"
										onClick={() => {
											setAppSelected("Pedimento");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileContract} />
										Pedimentos
									</Link>
								</li>
								<li>
									<Link
										to="/immex/partida"
										className="w-full"
										onClick={() => {
											setAppSelected("Partida");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faListCheck} />
										Partidas
									</Link>
								</li>
								<li>
									<Link
										to="/immex/checkout"
										className="w-full"
										onClick={() => {
											setAppSelected("Checkout");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBoxesPacking} />
										Checkouts
									</Link>
								</li>
								<li>
									<Link
										to="/immex/location"
										className="w-full"
										onClick={() => {
											setAppSelected("Location");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faMapPin} />
										Locations
									</Link>
								</li>
																<li>
									<Link
										to="/warehouse/machinetracker"
										className="w-full"
										onClick={() => {
											setAppSelected("MachineTracker");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faScrewdriverWrench} />
										Machine Tracker
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}
				{hasPermission("LCU Manager", "warehouse") ? ( //despues agregar permisos especiales
					<li>
						<div
							className={sectionClassName("warehouse")}
							data-testid="menu-section-warehouse"
							onClick={() =>
								setWarehouseDropdownOpen(warehouseDropdownOpen => !warehouseDropdownOpen)
							}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faWarehouse} className="mr-2" />
								LCU Manager
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!warehouseDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!warehouseDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/warehouse/lcubox"
										className="w-full"
										onClick={() => {
											setAppSelected("LCU");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBoxesStacked} />
										LCU
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/warehouse/cpu"
										className="w-full"
										onClick={() => {
											setAppSelected("CPU");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faMicrochip} />
										CPU
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/warehouse/delivery"
										className="w-full"
										onClick={() => {
											setAppSelected("Delivery");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faTruckRampBox} />
										Delivery
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/warehouse/bom"
										className="w-full"
										onClick={() => {
											setAppSelected("Bom");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faDiagramProject} />
										Bom
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/warehouse/partnumber"
										className="w-full"
										onClick={() => {
											setAppSelected("Partnumbers");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBoxesStacked} />
										Partnumbers
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}
				{hasPermission("expenses", "expense") ? ( //despues agregar permisos especiales
					<li>
						<div
							className={sectionClassName("expenses")}
							data-testid="menu-section-expenses"
							onClick={() =>
								setExpensesDropdownOpen(expensesDropdownOpen => !expensesDropdownOpen)
							}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faReceipt} className="mr-2" />
								Expenses v1.1
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!expensesDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!expensesDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/user/home"
										className="w-full"
										onClick={() => {
											setAppSelected("Home");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faHouse} />
										Home
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/user/historical"
										className="w-full"
										onClick={() => {
											setAppSelected("Historical");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Historical
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/user/budget"
										className="w-full"
										onClick={() => {
											setAppSelected("Budget");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCoins} />
										Budget
									</Link>
								</li>
								<li>
									<Link
										to="/user/expense"
										className="w-full"
										onClick={() => {
											setAppSelected("Expense");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faReceipt} />
										<span>Expense</span>
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{canManageSchedule ? (
					<li>
						<div
							className={sectionClassName("schedule")}
							data-testid="menu-section-schedule"
							onClick={() =>
								setScheduleDropdownOpen(scheduleDropdownOpen => !scheduleDropdownOpen)
							}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faCalendarDays} className="mr-2" />
								Schedule v2.0
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!scheduleDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!scheduleDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/schedule-v2"
										className="w-full"
										onClick={() => {
											setAppSelected("Schedule 2.0");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faTimeline} />
										<span>Schedule 2.0</span>
										<span className="ml-auto rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-emerald-700">
											New
										</span>
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/schedule-v2/dispatch"
										className="w-full"
										onClick={() => {
											setAppSelected("Dispatch Board");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClipboardUser} />
										<span>Dispatch Board</span>
										<span className="ml-auto rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-emerald-700">
											New
										</span>
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/schedule-v2/week-board"
										className="w-full"
										onClick={() => {
											setAppSelected("FSE Week Board");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCalendarDays} />
										<span>FSE Week Board</span>
										<span className="ml-auto rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-emerald-700">
											New
										</span>
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/schedule-v2/capacity"
										className="w-full"
										onClick={() => {
											setAppSelected("FSE Capacity");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faUsersViewfinder} />
										<span>FSE Capacity</span>
										<span className="ml-auto rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-emerald-700">
											New
										</span>
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/schedule-v2/templates"
										className="w-full"
										onClick={() => {
											setAppSelected("Plantillas");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCopy} />
										<span>Plantillas</span>
										<span className="ml-auto rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-emerald-700">
											New
										</span>
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/schedule-v2/settings"
										className="w-full"
										onClick={() => {
											setAppSelected("Schedule Settings");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faGear} />
										<span>Schedule Settings</span>
										<span className="ml-auto rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-emerald-700">
											New
										</span>
									</Link>
								</li>
								<li className="w-full">
									<a
										href={scheduleManualUrl()}
										target="_blank"
										rel="noreferrer"
										className="w-full"
										onClick={() => {
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBook} />
										<span>Manual</span>
									</a>
								</li>
								<li className="w-full">
									<Link
										to="/utils/changeLog/schedule"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : effectivePermissions.schedule == "user" ? (
					<>
						<li>
							<Link
								to="/schedule-v2"
								className="w-full"
								onClick={() => {
									setAppSelected("Schedule 2.0");
									document.getElementById("my-drawer-3").checked = false;
								}}
							>
								<FontAwesomeIcon icon={faCalendarDays} />
								Schedule 2.0
							</Link>
						</li>

						<li className="w-full">
							<Link
								to="/utils/changeLog/quotes"
								//state={{ appName: "quotes" }}
								className="w-full"
								onClick={() => {
									setAppSelected("Change Log");
									document.getElementById("my-drawer-3").checked = false;
								}}
							>
								<FontAwesomeIcon icon={faClockRotateLeft} />
								Change Log
							</Link>
						</li>
					</>
				) : (
					<></>
				)}

				{effectivePermissions.tickets == "admin" || effectivePermissions.tickets == "fse" ? (
					<li>
						<div
							className={sectionClassName("tickets")}
							data-testid="menu-section-tickets"
							onClick={() =>
								setTicketsDropdownOpen(ticketsDropdownOpen => !ticketsDropdownOpen)
							}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faTicket} className="mr-2" />
								SHDesk beta v1.2
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!ticketsDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!ticketsDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className={`${effectivePermissions.tickets == "fse" ? "hidden" : ""} w-full `}>
									<Link
										to="/tickets/dashboard"
										className="w-full"
										onClick={() => {
											setAppSelected("Tickets Dashboard");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faChartColumn} />
										Dashboard
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/tickets/admin"
										className="w-full"
										onClick={() => {
											setAppSelected("Tickets Admin");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClipboardQuestion} />
										Tickets table
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/tickets/action-trackers"
										className="w-full"
										onClick={() => {
											setAppSelected("Action Trackers 2025");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faListCheck} />
										Action Trackers 2025
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/tickets/action-trackers-2026"
										className="w-full"
										onClick={() => {
											setAppSelected("Action Trackers 2026");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faListCheck} />
										Action Trackers 2026
									</Link>
								</li>
								<li className={`${effectivePermissions.tickets == "fse" ? "hidden" : ""} w-full `}>
									<Link
										to="/tickets/usersTable"
										className="w-full"
										onClick={() => {
											setAppSelected("Tickets Users Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faUsersGear} />
										Users Table
									</Link>
								</li>
								<li className="hidden">
									<Link
										to="/schedule/user"
										className="w-full"
										onClick={() => {
											setAppSelected("Schedule User");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCalendarDays} />
										<span>User View</span>
									</Link>
								</li>
								<li>
									<Link
										to="/tickets/new"
										className="w-full"
										onClick={() => {
											setAppSelected("New Ticket");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileCirclePlus} />
										<span>New Ticket</span>
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/utils/changeLog/schedule"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : effectivePermissions.tickets == "user" ? (
					<li>
						<div
							className={sectionClassName("tickets")}
							data-testid="menu-section-tickets"
							onClick={() =>
								setTicketsDropdownOpen(ticketsDropdownOpen => !ticketsDropdownOpen)
							}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faTicket} className="mr-2" />
								SHDesk beta v1.2
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!ticketsDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!ticketsDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/tickets/user"
										className="w-full"
										onClick={() => {
											setAppSelected("Tickets Admin");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faTicket} />
										Tickets
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/tickets/action-trackers"
										className="w-full"
										onClick={() => {
											setAppSelected("Action Trackers 2025");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faListCheck} />
										Action Trackers 2025
									</Link>
								</li>
								<li>
									<Link
										to="/tickets/new"
										className="w-full"
										onClick={() => {
											setAppSelected("New Ticket");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileCirclePlus} />
										<span>New Ticket</span>
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/utils/changeLog/schedule"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{effectivePermissions.jigs == "admin" ? (
					<li>
						<div
							className={sectionClassName("jigs")}
							data-testid="menu-section-jigs"
							onClick={() => setJigsDropdownOpen(jigsDropdownOpen => !jigsDropdownOpen)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faTruckFast} className="mr-2" />
								Jigs v1.0
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!jigsDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!jigsDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/jigs"
										className="w-full"
										onClick={() => {
											setAppSelected("Jigs Admin");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faScrewdriverWrench} />
										Jigs Admin
									</Link>
								</li>
								<li>
									<Link
										to="/jigsTable"
										className="w-full"
										onClick={() => {
											setAppSelected("Jigs Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faListCheck} />
										<span>Jigs Table</span>
									</Link>
								</li>

								<li>
									<Link
										to="/jigsDashboard"
										className="w-full"
										onClick={() => {
											setAppSelected("Jigs Dashboard");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faChartColumn} />
										<span>Jigs Dashboard</span>
									</Link>
								</li>

								<li>
									<Link
										to="/utils/changeLog/jigs"
										//state={{ appName: "jigs" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										<span>Change Log</span>
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{hasPermission("purchaseOrders") ? (
					<li>
						<div
							className={sectionClassName("purchaseOrders")}
							data-testid="menu-section-purchase-orders"
							onClick={() => setPoDropdownOpen(poDropdownOpen => !poDropdownOpen)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faCartShopping} className="mr-2" />
								Purchase Orders v1.0
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!poDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!poDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								{effectivePermissions.purchaseOrders == "admin" ? (
									<li className="w-full">
										<Link
											to="/po/dashboard"
											className="w-full"
											onClick={() => {
												setAppSelected("PO Dashboard");
												document.getElementById("my-drawer-3").checked = false;
											}}
										>
											<FontAwesomeIcon icon={faChartColumn} />
											PO Dashboard
										</Link>
									</li>
								) : (
									<></>
								)}

									<li>
									<Link
										to="/po/table"
										className="w-full"
										onClick={() => {
											setAppSelected("Purchase Orders Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faReceipt} />
										PO Table
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/po/transactions"
										className="w-full"
										onClick={() => {
											setAppSelected("PO Transactions");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										PO Transactions
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/utils/changeLog/purchaseOrders"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{effectivePermissions.quotes == "admin" || effectivePermissions.quotes == "user" ? (
					<li>
						<div
							className={sectionClassName("quotes")}
							data-testid="menu-section-quotes"
							onClick={() => setQuotesDropdownOpen(quotesDropdownOpen => !quotesDropdownOpen)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faQuoteLeft} className="mr-2" />
								Quotes v2.0
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!quotesDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!quotesDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/quotes/create"
										className="w-full"
										onClick={() => {
											setAppSelected("Create Quote");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileSignature} />
										Create Quote
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/quotes/dashboard"
										className="w-full"
										onClick={() => {
											setAppSelected("Quote Dashboard");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faChartColumn} />
										Quote Dashboard
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/quotes"
										className="w-full"
										onClick={() => {
											setAppSelected("Quotes Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileLines} />
										Quotes Table
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/utils/tyc"
										className="w-full"
										onClick={() => {
											setAppSelected("TyC Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileContract} />
										TyC Table
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/utils/changeLog/quotes"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{effectivePermissions.utils == "admin" ? (
					<li>
						<div
							className={sectionClassName("utils")}
							data-testid="menu-section-utils"
							onClick={() => setUtilsDropdownOpen(utilsDropdownOpen => !utilsDropdownOpen)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faGears} className="mr-2" />
								Utils
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!utilsDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!utilsDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/utils/clients-new"
										className="w-full"
										onClick={() => {
											setAppSelected("Clients Table New");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faAddressBook} />
										Clients Table New
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/utils/users"
										className="w-full"
										onClick={() => {
											setAppSelected("Users Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faUsersGear} />
										Users Table
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/utils/email-logs"
										className="w-full"
										onClick={() => {
											setAppSelected("Email Logs");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faEnvelope} />
										Email Logs
										<NewFeatureBadge featureKey="email-logs" />
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/utils/employees"
										className="w-full"
										onClick={() => {
											setAppSelected("Employees Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faIdBadge} />
										Employees Table
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/utils/tyc"
										className="w-full"
										onClick={() => {
											setAppSelected("TyC Table");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faFileContract} />
										TyC Table
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/utils/changeLog/utils"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/utils/jobs"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Jobs");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBug} />
										Jobs beta
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/utils/public-images"
										className="w-full"
										onClick={() => {
											setAppSelected("Public Images");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faImage} />
										Public Images
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{effectivePermissions.utils == "admin" ? (
					<li>
						<div
							className={sectionClassName("workflow")}
							data-testid="menu-section-workflow"
							onClick={() => setThingsToDoDropdownOpen(prev => !prev)}
						>
							<Link className="w-full">
								<FontAwesomeIcon icon={faCodeFork} className="mr-2" />
								Workflow
							</Link>
							<FontAwesomeIcon
								icon={faChevronDown}
								className={`delay-400 duration-500 transition-all ${
									!thingsToDoDropdownOpen && "rotate-180"
								}
											`}
							/>
						</div>
						<div
							className={`${
								!thingsToDoDropdownOpen ? "-top-20 hidden delay-0" : "top-0 delay-900"
							} relative duration-900 ease-in transition-all delay-500 overflow-hidden `}
						>
							<ul className="w-full menu menu-compact">
								<li className="w-full">
									<Link
										to="/workflow"
										className="w-full"
										onClick={() => {
											setAppSelected("WorkFlow");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faDiagramProject} />
										WorkFlow
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/workflow/board"
										className="w-full"
										onClick={() => {
											setAppSelected("Workflow Board");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faCodeFork} />
										Board
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/workflow/my-reported"
										className="w-full"
										onClick={() => {
											setAppSelected("My Reported Issues");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faBug} />
										My Reported Issues
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/workflow/my-assigned"
										className="w-full"
										onClick={() => {
											setAppSelected("My Assigned Work");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClipboardUser} />
										My Assigned Work
									</Link>
								</li>
								<li className="w-full">
									<Link
										to="/workflow/roadmap"
										className="w-full"
										onClick={() => {
											setAppSelected("Roadmap");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faTimeline} />
										Roadmap
									</Link>
								</li>

								<li className="w-full">
									<Link
										to="/utils/changeLog/utils"
										//state={{ appName: "quotes" }}
										className="w-full"
										onClick={() => {
											setAppSelected("Change Log");
											document.getElementById("my-drawer-3").checked = false;
										}}
									>
										<FontAwesomeIcon icon={faClockRotateLeft} />
										Change Log
									</Link>
								</li>
							</ul>
						</div>
					</li>
				) : (
					<></>
				)}

				{effectivePermissions.doc == "admin" ? ( //Dashboard Operaciones de Comercio
					<li>
						<Link
							to="/OperacionesComercio/Dashboard"
							className="w-full"
							onClick={() => {
								setAppSelected("Dashboard Operaciones Comercio");
								document.getElementById("my-drawer-3").checked = false;
							}}
						>
							<FontAwesomeIcon icon={faShop} />
							Dashboard Operaciones Comercio
						</Link>
					</li>
				) : (
					<></>
				)}
			</ul>
		</div>
		<ToastContainer
			position="bottom-right"
			autoClose={5000}
			hideProgressBar={false}
			newestOnTop={false}
			closeOnClick
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover
			theme={theme}
		/>
	</div>
);
};

export default Menu;
